import { render } from "./MasterTop.vue?vue&type=template&id=6461e874&scoped=true"
import script from "./MasterTop.vue?vue&type=script&lang=js"
export * from "./MasterTop.vue?vue&type=script&lang=js"

import "./MasterTop.vue?vue&type=style&index=0&id=6461e874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6461e874"]])

export default __exports__